import { useEffect, useState } from 'react';
import api from '../lib/api';

export default function ActivityPage() {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/activities?limit=50')
      .catch(() => [])
      .finally(() => setLoading(false));
  }, []);

  const typeIcon = t => ({ email:'✉', call:'📞', meeting:'📅', task:'✓', note:'📝' }[t] || '•');

  return (
    <>
      <div className="card">
        <div className="section-title">All activity</div>
        {loading
          ? <div style={{ fontSize:13, color:'var(--text-tertiary)' }}>Loading…</div>
          : activities.length === 0
            ? <div style={{ fontSize:13, color:'var(--text-tertiary)' }}>No activity yet. Activity will appear here as you log emails, calls, and meetings.</div>
            : <div className="activity-list">
                {activities.map(a => (
                  <div className="activity-item" key={a.id}>
                    <div className="activity-icon">{typeIcon(a.type)}</div>
                    <div>
                      <div className="activity-text">{a.subject}</div>
                      <div className="activity-time">
                        {a.user_name && <span>{a.user_name} · </span>}
                        {new Date(a.created_at).toLocaleString()}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
        }
      </div>
    </>
  );
}